module.exports = __webpack_public_path__ + "img/firma-2.48c83628.png";